import React, { useState } from 'react';
import { Star, MessageSquare, Send, CheckCircle2, User, ThumbsUp } from 'lucide-react';
import './CustomerReviewsSection.css';

const initialReviews = [
  {
    id: 1,
    name: "م. إبراهيم سعيد",
    role: "رجل أعمال - التجمع الخامس",
    rating: 5.0,
    date: "منذ 3 أيام",
    service: "سحب سطحة هيدروليكية",
    comment: "وصلني ونش الإنقاذ بعد 10 دقائق فقط من الاتصال على طريق السويس. السائق كان متعاون جداً والسطحة الهيدروليكية رفعت سيارتي المرسيدس باحترافية تامة بدون أي خدش."
  },
  {
    id: 2,
    name: "خالد أكرم",
    role: "صاحب شركة - مدينة نصر",
    rating: 4.5,
    date: "منذ أسبوع",
    service: "إنقاذ سيارة على الدائري",
    comment: "خدمة سريعة وسعر مناسب جداً مقارنة بباقي الشركات. السائق وصل في 15 دقيقة على الطريق الدائري وكان محترم وأمين والتسعيرة واضحة بدون أي مفاجآت."
  },
  {
    id: 3,
    name: "د. طارق العوضي",
    role: "طبيب استشاري - الشيخ زايد",
    rating: 5.0,
    date: "منذ أسبوعين",
    service: "طوارئ منتصف الليل 2 AM",
    comment: "تعطلت سيارتي في الشيخ زايد الساعة 2 صباحاً وكنت قلقاً جداً، اتصلت برقم الطوارئ وخلال 12 دقيقة كان الونش متواجداً ونقل السيارة لمركز الصيانة بأمان تام."
  },
  {
    id: 4,
    name: "م. أحمد عبد الفتاح",
    role: "مهندس اتصالات - الإسكندرية",
    rating: 4.0,
    date: "منذ 3 أسابيع",
    service: "شحن بطارية ومساعدة طريق",
    comment: "تجربة ممتازة في شحن البطارية على طريق مصر إسكندرية الصحراوي. الفني كان سريع والمعدة حديثة جداً، السعر كان عادل ومتفق عليه مسبقاً بالتليفون."
  },
  {
    id: 5,
    name: "حسام الشناوي",
    role: "محاسب قانوني - المعادي",
    rating: 4.5,
    date: "منذ شهر",
    service: "سحب سيارة 4x4 دفع رباعي",
    comment: "سحبوا سيارة الدفع الرباعي بتاعتي من المعادي لصقر قريش بدون أي مشاكل في الفتيس أو الدفرنس. ناس فاهمة شغلها وعندهم التزام عالي بالمواعيد."
  },
  {
    id: 6,
    name: "أشرف ممدوح",
    role: "مدير مبيعات - 6 أكتوبر",
    rating: 5.0,
    date: "منذ شهر",
    service: "نقل سيارة بين المحافظات",
    comment: "أفضل خدمة ونش اتعاملت معاها في مصر. تم نقل سيارتي من أكتوبر إلى الساحل الشمالي مع تتبع GPS كامل وسعر ثابت بدون طلب أي إكراميات إضافية."
  }
];

const CustomerReviewsSection = () => {
  const [reviews, setReviews] = useState(initialReviews);
  const [formData, setFormData] = useState({
    name: '',
    location: '',
    rating: 5,
    comment: '',
    service: 'سحب وإنقاذ سيارات'
  });
  const [submitted, setSubmitted] = useState(false);
  const [hoverRating, setHoverRating] = useState(0);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name.trim() || !formData.comment.trim()) return;

    const newReview = {
      id: Date.now(),
      name: formData.name.trim(),
      role: formData.location ? `عميل من ${formData.location.trim()}` : "عميل تم التحقق منه",
      rating: Number(formData.rating),
      date: "الآن",
      service: formData.service,
      comment: formData.comment.trim()
    };

    setReviews([newReview, ...reviews]);
    setSubmitted(true);
    setFormData({ name: '', location: '', rating: 5, comment: '', service: 'سحب وإنقاذ سيارات' });
    setTimeout(() => setSubmitted(false), 6000);
  };

  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalf = rating % 1 !== 0;

    for (let i = 1; i <= 5; i++) {
      if (i <= fullStars) {
        stars.push(<Star key={i} size={18} fill="#f59e0b" color="#f59e0b" />);
      } else if (i === fullStars + 1 && hasHalf) {
        stars.push(
          <span key={i} style={{ position: 'relative', display: 'inline-block' }}>
            <Star size={18} color="#f59e0b" />
            <span style={{ position: 'absolute', right: 0, top: 0, width: '50%', overflow: 'hidden' }}>
              <Star size={18} fill="#f59e0b" color="#f59e0b" />
            </span>
          </span>
        );
      } else {
        stars.push(<Star key={i} size={18} color="#d1d5db" />);
      }
    }
    return stars;
  };

  return (
    <section className="customer-reviews-section" id="customer-reviews">
      <div className="reviews-container">
        
        {/* Section Header */}
        <div className="reviews-header">
          <span className="reviews-badge">
            <ThumbsUp size={16} /> تجارب حقيقية من عملائنا
          </span>
          <h2 className="reviews-main-title">آراء وتقييمات عملاء ونش محمد بحر</h2>
          <p className="reviews-lead">
            نفخر بخدمة أكثر من 13,000 سائق في مصر بتقييم عام <strong>4.8 / 5.0</strong> على مدار أكثر من 20 عاماً من الخبرة والاحترافية.
          </p>

          {/* Rating Summary Bar */}
          <div className="rating-summary-card">
            <div className="rating-score-box">
              <span className="big-score">4.8</span>
              <div className="stars-row">{renderStars(4.8)}</div>
              <span className="votes-count">بناءً على 1,648 تقييم حقيقي</span>
            </div>
            <div className="rating-breakdown">
              <div className="breakdown-bar">
                <span>5 نجوم</span>
                <div className="bar-track"><div className="bar-fill" style={{ width: '84%' }}></div></div>
                <span>84%</span>
              </div>
              <div className="breakdown-bar">
                <span>4 نجوم</span>
                <div className="bar-track"><div className="bar-fill" style={{ width: '13%' }}></div></div>
                <span>13%</span>
              </div>
              <div className="breakdown-bar">
                <span>3 نجوم</span>
                <div className="bar-track"><div className="bar-fill" style={{ width: '3%' }}></div></div>
                <span>3%</span>
              </div>
            </div>
          </div>
        </div>

        {/* Reviews Cards Grid */}
        <div className="reviews-grid">
          {reviews.map((rev) => (
            <div key={rev.id} className="review-card">
              <div className="review-card-top">
                <div className="reviewer-info">
                  <div className="reviewer-avatar">
                    <User size={20} />
                  </div>
                  <div>
                    <h4 className="reviewer-name">{rev.name}</h4>
                    <span className="reviewer-role">{rev.role}</span>
                  </div>
                </div>
                <div className="review-rating-box">
                  <div className="stars-row">{renderStars(rev.rating)}</div>
                  <span className="rating-num">{rev.rating} / 5</span>
                </div>
              </div>
              <p className="review-comment">"{rev.comment}"</p>
              <div className="review-card-footer">
                <span className="review-service"><CheckCircle2 size={14} color="#10b981" /> {rev.service}</span>
                <span className="review-date">{rev.date}</span>
              </div>
            </div>
          ))}
        </div>

        {/* Leave a Review Form */}
        <div className="leave-review-wrapper">
          <div className="leave-review-card">
            <div className="form-header">
              <MessageSquare size={26} color="#0077ff" />
              <div>
                <h3>شاركنا تجربتك ورأيك في الخدمة</h3>
                <p>رأيك يهمنا ويساعدنا في تطوير وتحديث خدمات الإنقاذ على مدار 24 ساعة.</p>
              </div>
            </div>

            {submitted ? (
              <div className="review-success-msg">
                <CheckCircle2 size={32} color="#10b981" />
                <div>
                  <h4>شكراً جزيلاً لمشاركتك تقييمك!</h4>
                  <p>تم استلام تقييمك بنجاح وتمت إضافته إلى صفحة التقييمات. نقدر ثقتك في ونش محمد بحر.</p>
                </div>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="review-form">
                <div className="form-row">
                  <div className="form-group">
                    <label>الاسم الكامل *</label>
                    <input 
                      type="text" 
                      placeholder="مثال: أحمد محمود"
                      value={formData.name}
                      onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>المنطقة / الطريق *</label>
                    <input 
                      type="text" 
                      placeholder="مثال: التجمع الخامس، طريق السويس، المعادي"
                      value={formData.location}
                      onChange={(e) => setFormData({ ...formData, location: e.target.value })}
                      required
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>نوع الخدمة المقدمة</label>
                    <select 
                      value={formData.service}
                      onChange={(e) => setFormData({ ...formData, service: e.target.value })}
                    >
                      <option value="سحب سطحة هيدروليكية">سحب سطحة هيدروليكية</option>
                      <option value="إنقاذ سيارات طوارئ">إنقاذ سيارات طوارئ</option>
                      <option value="شحن وتوصيل بطارية">شحن وتوصيل بطارية</option>
                      <option value="تغيير إطار ومساعدة طريق">تغيير إطار ومساعدة طريق</option>
                      <option value="تزويد وقود طوارئ">تزويد وقود طوارئ</option>
                      <option value="نقل سيارة بين المحافظات">نقل سيارة بين المحافظات</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label>تقييمك للخدمة (اختر من 1 إلى 5 نجوم)</label>
                    <div className="interactive-stars">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <button
                          type="button"
                          key={star}
                          className="star-btn"
                          onClick={() => setFormData({ ...formData, rating: star })}
                          onMouseEnter={() => setHoverRating(star)}
                          onMouseLeave={() => setHoverRating(0)}
                          aria-label={`تقييم ${star} نجوم`}
                        >
                          <Star 
                            size={26} 
                            fill={(hoverRating || formData.rating) >= star ? "#f59e0b" : "none"}
                            color={(hoverRating || formData.rating) >= star ? "#f59e0b" : "#9ca3af"}
                          />
                        </button>
                      ))}
                      <span className="selected-rating-label">
                        {formData.rating === 5 ? "ممتاز جداً (5 نجوم)" : 
                         formData.rating === 4 ? "جيد جداً (4 نجوم)" : 
                         formData.rating === 3 ? "جيد (3 نجوم)" : 
                         formData.rating === 2 ? "مقبول (نجمتان)" : "ضعيف (نجمة واحدة)"}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <label>اكتب مراجعتك وتجربتك بالتفصيل *</label>
                  <textarea 
                    rows={4}
                    placeholder="كيف كانت سرعة وصول الونش؟ هل كان السائق متعاوناً؟ هل كان السعر مناسباً؟"
                    value={formData.comment}
                    onChange={(e) => setFormData({ ...formData, comment: e.target.value })}
                    required
                  ></textarea>
                </div>

                <button type="submit" className="submit-review-btn">
                  <Send size={18} /> إرسال التقييم الآن
                </button>
              </form>
            )}
          </div>
        </div>

      </div>
    </section>
  );
};

export default CustomerReviewsSection;
